module.exports = __webpack_public_path__ + "img/stock4.0139ffbb.png";